import { Component, Input, Output, OnInit, forwardRef, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-form-number',
  templateUrl: './form-number.component.html',
  styleUrls: ['./form-number.component.sass'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormNumberComponent),
      multi: true
    }
  ]
})
export class FormNumberComponent implements OnInit, ControlValueAccessor {
  @Input()  required = false;
  @Input()  name = '';
  @Input()  placeholder = '';
  @Input()  step = 1;
  @Input()  max: number = null;
  @Input()  min: number = null;
  @Input()  width = null;
  @Input()  nullable = false;
  @Input()  loopable = false;
  @Output() contentChange: EventEmitter<any>;

  public content: number;

  propagateChange = (_: any) => {};

  constructor() {
    this.contentChange = new EventEmitter();
  }

  ngOnInit() {
  }

  writeValue(value: any) {
    if (value !== undefined) {
      this.content = value;
    }
  }

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  registerOnTouched() {}

  change(content: any) {
    this.propagateChange(content);
    this.contentChange.emit(content);
  }

  onContentChange(content: any) {
    this.change(content);
  }

  onPlus() {
    const min  = this.min;
    const max  = this.max;
    const step = this.step;

    if ((this.content === null || this.content < min) && min !== null) {
      this.content = +min;
    } else if (this.content < max || max === null) {
      this.content += +step;
    } else if (this.loopable && min !== null) {
      if (this.nullable && this.content !== null) {
        this.content = null;
      } else {
        this.content = +min;
      }
    }

    this.change(this.content);
  }

  onMinus() {
    const min  = this.min;
    const max  = this.max;
    const step = this.step;

    if (this.nullable && this.content === 0) {
      this.content = null;
    } else if (this.content > min || min === null) {
      this.content -= +step;
    } else if (this.loopable && max !== null) {
      if (this.nullable && this.content !== null) {
        this.content = null;
      } else {
        this.content = +max;
      }
    }

    this.change(this.content);
  }

  isPlusDisabled() {
    if (this.loopable) {
      return false;
    }

    return this.max !== null && this.content >= this.max;
  }

  isMinusDisabled() {
    if (this.loopable && this.max !== null) {
      return false;
    }

    if (this.nullable && this.content === 0) {
      return false;
    }

    return this.min !== null && this.content <= this.min;
  }
}
